import React from "react";
import Tooltip from "../Tooltip";
import { TableLinkSurface, TableTextSurface } from "./TablePrimitives.styles";
import type { TableLinkProps, TableTextProps } from "./TablePrimitives.types";

export const TableText: React.FC<TableTextProps> = ({
  children,
  tone = "default",
  weight = 400,
  numeric = false,
  truncate = true,
  maxWidth,
  tooltipContent,
}) => {
  const surface = (
    <TableTextSurface
      $tone={tone}
      $weight={weight}
      $numeric={numeric}
      $truncate={truncate}
      $maxWidth={maxWidth}
    >
      {children}
    </TableTextSurface>
  );

  if (!truncate) return surface;

  return (
    <Tooltip
      content={tooltipContent ?? children}
      onlyWhenOverflowed
      block
    >
      {surface}
    </Tooltip>
  );
};

export const TableLink: React.FC<TableLinkProps> = ({
  href,
  children,
  truncate = true,
  maxWidth,
  external = false,
  tooltipContent,
}) => {
  const surface = (
    <TableLinkSurface
      href={href}
      $truncate={truncate}
      $maxWidth={maxWidth}
      target={external ? "_blank" : undefined}
      rel={external ? "noopener noreferrer" : undefined}
    >
      {children}
    </TableLinkSurface>
  );

  if (!truncate) return surface;

  return (
    <Tooltip
      content={tooltipContent ?? children}
      onlyWhenOverflowed
      block
    >
      {surface}
    </Tooltip>
  );
};
